var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.hero},[_c('Column',[_c('div',{class:[
      _vm.$style.image,
      _vm.visible ? _vm.$style.visible : null,
      _vm.$style[("background-" + (_vm.data['cover-size']))]
    ]},[_c('img',{attrs:{"data-hero-image":"","data-animated":"","data-cover":_vm.id,"src":_vm.data.local_url_cover || _vm.data.cover.url,"alt":_vm.data.cover.alt}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }